import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {AuthService} from '../services/auth.service';
import {SecurityTransactionType} from '../models/security-transaction-type.enum';
import { HttpResponseHandlerService } from '../services/http-response-handler.service';

@Injectable()
/**
 * Requires the currently logged in user to have a specified security transaction claim, denoted by - data: { transaction: SecurityTransactionType.SecurityTransactionClaim }
*/
export class UserTransactionAuthGuard implements CanActivate {

    constructor(private _auth: AuthService,
        private router: Router,
        private httpResponseHandlerService: HttpResponseHandlerService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const routeData: any = route.data;
        if (routeData != undefined) {
            if (routeData.name != undefined && routeData.name.length > 0) {
                return this.checkUserHasTransactionName(routeData.name);
            } else if (routeData.transaction != undefined) {
                return this.checkUserHasTransaction(routeData.transaction);
            }
        }
        return false;
    }

    /**
     * Checks security transaction claims by name
     * @param transaction
     */
    checkUserHasTransactionName(transaction: string | string[]): boolean {
        // if something has happened to the business unit, then user cannot have a security claim
        if (!this._auth.hasBusinessUnitAccess || !this._auth.hasClaim(this._auth.transactionClaim, transaction)) {
            this.handleFail();
            return false;
        } else {
            return true;
        }
    }

    /**
     * Checks security transaction claims by enum
     * @param transaction
     */
    checkUserHasTransaction(transaction: SecurityTransactionType | SecurityTransactionType[]): boolean {
        // if something has happened to the business unit, then user cannot have a security claim
        if (!this._auth.hasBusinessUnitAccess || !this._auth.hasSecurityTransactionClaim(transaction)) {
            this.handleFail();
            return false;
        } else {
            return true;
        }
    }

    handleFail() {
        this.httpResponseHandlerService.displayAccessDenied();
        this.router.navigate(['/']);
    }

}
